import api from "@lib/api/client";
import { queryKeys } from "@lib/api/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { API_ENDPOINTS } from "../config/constants";

export interface TicketsMetrics {
  total: number;
  byStatus: Record<string, number>;
  byCategory: Record<string, number>;
  trends: {
    total: number;
    open: number;
    proposition_solution: number;
    resolved: number;
  };
}

export function useTicketsMetrics() {
  return useQuery<TicketsMetrics>({
    queryKey: queryKeys.tickets.metrics(),
    queryFn: async () => {
      const response = await api.get<TicketsMetrics>(API_ENDPOINTS.TICKETS.METRICS);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    refetchInterval: 2 * 60 * 1000,
  });
}
